import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Font from '../../../../../SPRINTA/atoms/Font'
import { Col, Row, Container } from '../../../../../SPRINTA/v2/atoms/Grid'
import Button from '../../../../../SPRINTA/v2/atoms/Button'
import FontIcon from '../../../../../SPRINTA/v2/atoms/FontIcon'
import { Text } from '../../../../../SPRINTA/v2/atoms/Form'
import SprintaTips from '../../../../../SPRINTA/molecules/SprintaTips'
import Modal from '../../../../../SPRINTA/v2/atoms/Modal'
import style from './style.css'
import Box from '../../../../../SPRINTA/atoms/Box';
import * as user from '../../../../utils/user';
import * as billing from '../../../../utils/billing';
import PlaceHolder from '../../../../../SPRINTA/v2/atoms/Placeholder'
import Display from '../../../../../SPRINTA/v2/atoms/Display'
import T from '../../../../../SPRINTA/translate/T'
import * as formatter from '../../../../../SPRINTA/helpers/Formatter'




function ConfigData(props) {
	
	const [modal, setModal] = useState(false)
	const [loading, setLoading] = useState(false)
	const [loadingCashOut, setLoadingCashOut] = useState(false)
	const [loadingAll, setLoadingAll] = useState(true)
	const [bankId, setBankId] = useState(null)
	const [amount, setAmount] = useState(0)
	const [extracts, setExtracts] = useState([])
	const [report, setReport] = useState([])
	const [errorCashOut, setErrorCashOut] = useState(false)
	const [errorMessage, setErrorMessage] = useState([])

	function verifyBank() {
		setLoading(true)
		if(!bankId){		
			user.getFinance()
			.then(data => {
				if(data.result) {
					setBankId(data.result.id)
					setModal(true)
					setLoading(false)
				} else {
					setModal(true)
					setLoading(false)				
				}
			})
		} else {
			setModal(true)
			setLoading(false)				
		}
	}

	function requestCashOut(amount, bankId) {
		let amountUnformated = formatter.toDecimal(amount)*100
		setLoadingCashOut(true)
		billing.postCashOut(amountUnformated, bankId)
		.then((resp) => {
			if(resp.errors.length > 0){
				setErrorCashOut(true)
				setTimeout(() => {
					setErrorCashOut(false)
				}, 3000)
				setLoadingCashOut(false)
				setErrorMessage(resp.errors[0])
			} else {
				loadBilling()		
			}
		})
	}

	useEffect(() => {
		loadBilling()
	}, [])
	
	function loadBilling() {
		return new Promise((resolve) => {

			billing.postExtract()
			.then(resp => {
				setExtracts(resp.list)
				billing.postReport()
				.then(resp => {
					setReport(resp)
					setAmount(formatter.numberFormat(resp.available/100, 2, ',', '.'))
					setLoadingAll(false)
					setModal(false)
					setLoadingCashOut(false)
					resolve()
				})

			})
		})

	}

	if(loadingAll)
    return (
		<div style={{ float: 'left', width: '100%' }}>
			<Loading />
		</div>
	)

	return (
		<div style={{ float: 'left', width: '100%' }}>
			<Row>
				<Col size='12'>
					<Font heading='3' weight="100" style={{marginBottom: '30px'}}>{T.text('billing_data')}</Font>
				</Col>
			</Row>
			<Row>
				<Col size='12 6 6' spacing={1}>
					<Box style={{height:'100%', backgroundColor: '#f9f9f9', padding: '30px'}}>
						<div style={{marginBottom: '30px'}} >
							<FontIcon size={60} color='#9b9797' name='user_report' /><br />
						</div>
						<Font color='#9b9797' size='50' weight='100' style={{lineHeight: '1'}}>{`R$ ${formatter.numberFormat(report.blocked/100, 2, ',', '.')}`}</Font>
						<Font color='#9b9797' size='20'>{T.txt('cash_out_processing')}</Font>
					</Box>
				</Col>

				<Col size='12 6 6' spacing={1}>
					<Box style={{height:'100%', backgroundColor: '#f9f9f9', padding: '30px'}}>
						<div style={{marginBottom: '30px'}} >
							<FontIcon size={60} name='user_money' /><br />
						</div>
						<Font size='50' weight='100' style={{lineHeight: '1'}}>{`R$ ${formatter.numberFormat(report.available/100, 2, ',', '.')}`}</Font>
						<Font size='20' style={{marginBottom: '20px'}}>{T.txt('cash_out_available')}</Font><br />
						<Button primary loading={loading} onClick={() => verifyBank()} inline>{T.txt('cash_out_button')}</Button>
					</Box>
				</Col>
			</Row>
			<Row>
				<Col size='12' spacing={4} style={{ display: 'flex', alignItems: 'center' }}>
					<FontIcon size={30} name='alert' />
					<Display style={{lineHeight: '1', display: 'inline-block', maxWidth: '380px', marginLeft: '15px' }}>{T.text('cash_out_attention')}</Display>
				</Col>
			</Row>

			<Row>
				<Col size='12' spacing={1}>
					<Font heading='3' weight="100"><b>{T.txt('extract')}</b></Font>
				</Col>
				<Col size='12' spacing={2}>
					<Row>
						<div style={{ float: 'left', width: '100%', overflow: 'auto', paddingLeft: '15px', paddingRight: '15px' }}>

							<div className={style.tableBilling}  style={{ minWidth: '585px' }}>
								<div className={style.tableBillingTr}>
									<Col className={style.th} size='2'>
										<Font className={style.thContent}><b>{T.txt('date')}</b></Font>
										<div className={style.spacer}></div>
									</Col>
									<Col className={style.th} size='auto' grow='1'>
										<Font className={style.thContent}><b>{T.txt('description')}</b></Font>
										<div className={style.spacer}></div>
									</Col>
									<Col className={style.th} size='2'>
										<Font className={style.thContent}><b>{T.txt('amount')}</b></Font>
										<div className={style.spacer}></div>
									</Col>
									<Col className={style.th} size='2'>
										<Font className={style.thContent}><b>{T.txt('status')}</b></Font>
										<div className={style.spacer}></div>
									</Col>
								</div>
								{extracts.map(extract => (
									<div key={extract.id} className={style.tableBillingTr}>
										<Col className={style.td} size='2'>
											<Font className={style.tdContent}>{formatter.dateFormat('d/m/y', extract.date)}</Font>
											<div className={style.spacer}></div>
										</Col>
										<Col className={style.td}  size='auto' grow='1'>
											<Font className={style.tdContent}>{extract.description}</Font>
											<div className={style.spacer}></div>
										</Col>
										<Col className={style.td} size='2'>
											<Font className={style.tdContent} style={{ color: extract.amount > 0 ? "#A3BD31" : "#FF0000" }}>{`R$ ${formatter.numberFormat(extract.amount/100, 2, ',', '.')}`}</Font>
											<div className={style.spacer}></div>
										</Col>
										<Col className={style.td} size='2'>
											<Font className={style.tdContent}>{extract.status === 'WA' ? 'Processando' : extract.status === 'CO' ? 'Confirmado' : extract.status === 'DE' ? 'Negado' : ''}</Font>
											<div className={style.spacer}></div>
										</Col>
									</div>
								))}
							</div>
						</div>
					</Row>

				</Col>
			</Row>

			<Modal style={{width: !bankId ? '400' :'800px'}} active={modal} handleClose={() => setModal(false)}>
				{ bankId && (
					<form onSubmit={(e) => { e.preventDefault(); requestCashOut(amount, bankId) }}>
						<Font heading='3' weight="100" style={{marginBottom: '30px'}}>Solicitar <b>saque</b></Font>
						<SprintaTips style={{marginBottom: '30px'}}>
							Ao solicitar o saque é gerado um pedido interno para a equipe Sprinta. Dentro de alguns dias o valor será depositado na sua conta.
						</SprintaTips>
						<Text autofocus='true' label='Valor a ser sacado' mask='money_br' value={amount} onChange={(e) => {setAmount(e.target.value); if(errorCashOut)setErrorCashOut(false) }} style={{marginBottom: '20px'}} />
						<Display bold style={{color: '#FF0000', display: errorCashOut ? 'block' : 'none'}}>{errorMessage ? errorMessage.message : ''}</Display>
						<Button loading={loadingCashOut} style={{float: 'right'}} primary inline>Solicitar</Button>
					</form>
				)}
				{ !bankId && (
					<Row>
						<Col text='center'>
							<Font heading='3' weight="100" style={{marginBottom: '30px'}}>Você não possui conta cadastrada!</Font>
							<Display block style={{marginBottom: '20px'}}>É necessário ter uma conta cadastrada para efetuar saques.</Display>
							<Button secondary inline onClick={() => setModal(false)} style={{marginRight: '15px'}}>Cancelar</Button>
							<Link to={`/user/${props.match.params.user}/config/finance`}><Button primary inline>Cadastrar</Button></Link>
						</Col>
					</Row>
				)}				
			</Modal>
		</div>
	)
}

export default ConfigData

function Loading() {
    return (
        <div>
            <Container>
				<Row>
					<Col size='8 3'>
                        <PlaceHolder box style={{ height: '40px'}} />
                    </Col>
				</Row>
                <Row>
                    <Col size='12 6 6' spacing={1}>
                        <PlaceHolder box style={{ height: '500px'}} />
                    </Col>
					<Col size='12 6 6'>
                        <PlaceHolder box style={{ height: '500px'}} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/ConfigBilling/index.js